// extracted by mini-css-extract-plugin
export var antSteps = "mdx-module--ant-steps--rw32q";
export var antStepsDot = "mdx-module--ant-steps-dot--y8DqO";
export var antStepsHorizontal = "mdx-module--ant-steps-horizontal--oMLp8";
export var antStepsItemDescription = "mdx-module--ant-steps-item-description--fJ3pC";
export var antStepsItemIcon = "mdx-module--ant-steps-item-icon--Eaj2a";
export var antStepsItemTitle = "mdx-module--ant-steps-item-title--Az+ek";
export var antStepsSmall = "mdx-module--ant-steps-small--QCM4X";
export var antTypography = "mdx-module--ant-typography--UrCcw";
export var button = "mdx-module--button--ffzqc";
export var buttonLabel = "mdx-module--buttonLabel--6cDva";
export var content = "mdx-module--content--TA8vv";
export var editOnGitHub = "mdx-module--editOnGitHub--9Y8qY";
export var footer = "mdx-module--footer--91Obx";
export var footerElement = "mdx-module--footerElement--J3Q+-";
export var globalTocWrapper = "mdx-module--globalTocWrapper--kK2+Y";
export var hideOnReducedMotion = "mdx-module--hideOnReducedMotion--VPVyD";
export var newsletter = "mdx-module--newsletter--GotnL";
export var nextButton = "mdx-module--nextButton--1Z1SN";
export var noBullet = "mdx-module--noBullet--6R1Ow";
export var outerWrapper = "mdx-module--outerWrapper--bvL4M";
export var pageToc = "mdx-module--pageToc--7+NSp";
export var pageTocWrapper = "mdx-module--pageTocWrapper--xZfwX";
export var prevButton = "mdx-module--prevButton--DZUc4";
export var showOnReducedMotion = "mdx-module--showOnReducedMotion--nw8Vb";
export var tocGroup = "mdx-module--tocGroup--JbgIw";
export var tocGroupLabel = "mdx-module--tocGroupLabel--+bd7R";
export var tocLeaf = "mdx-module--tocLeaf--4CzKj";
export var tocLeafActive = "mdx-module--tocLeafActive--RMZD1";
export var tweetBox = "mdx-module--tweet-box--KplNr";
export var wrapper = "mdx-module--wrapper--qNQpf";